import { Box, List, Popover, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { LegislationSchedulesPopoverItem } from "./legislation-schedules-popover-item"

export function LegislationSchedulesPopover({ anchorEl, onClose, schedules, customScheduleCount = 0 }) {
    const open = Boolean(anchorEl)
    const hasAny = schedules?.length > 0 || customScheduleCount > 0

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{ paper: { sx: { mt: 0.5, minWidth: 280, maxWidth: 360 } } }}
        >
            <Box sx={{ maxHeight: 280, overflowY: "auto" }}>
                <If value={hasAny}>
                    <Bound onPick={onClose}>
                        <List dense disablePadding>
                            <Repeat list={schedules ?? []} item={<LegislationSchedulesPopoverItem />} />
                        </List>
                        <If truthy={customScheduleCount > 0}>
                            <Typography
                                variant="caption"
                                sx={{ display: "block", px: 2, py: 1, color: "text.secondary" }}
                                data-cy="legislation-schedules-popover-custom-count"
                            >
                                {customScheduleLabel()}
                            </Typography>
                        </If>
                    </Bound>
                    <Else>
                        <Box sx={{ px: 2, py: 1.5, color: "text.secondary", fontSize: 14 }}>No schedules</Box>
                    </Else>
                </If>
            </Box>
        </Popover>
    )

    function customScheduleLabel() {
        return `Used by ${customScheduleCount} custom ${customScheduleCount === 1 ? "schedule" : "schedules"}`
    }
}
